import $ from 'jquery';

export default function getReviews(params, reviewPageNum, focusId) {
    const pdpData = window.rcProps.pdp || {};
    params = params || {};

    const data = $.param({
        prodCode: pdpData.code,
        bodyType: params.bodyType,
        heightType: params.heightType,
        rating: params.rating,
        productSize: params.productSize,
        productColor: params.productColor,
        reviewSort: params.sort,
        reviewPageNum: reviewPageNum
    });
    $.ajax({
        url: "/r/ajax/PDPCustomerReviews.jsp",
        data: data,
        success: function(data) {
            const customerReviewMarkup = parseRtn(data);
            $('#pdp-review-area').html(customerReviewMarkup);
            setEventListeners();
            // Dropdown Effect for Ajax Review Content
            $('.js-dropdown').dropdown();
        },
        complete: function () {
            $('#' + focusId).focus();
        }
    });
}

function setEventListeners() {
    $(".js-customer-reviews").on("click", function(e) {
        e.preventDefault();
        const el = $(this);

        $.modal({
            url: el.data('modalUrl'),
            triggerOpen: true,
            type: "large",
            returnFocus: $(this),
        });
    });

    $("input[name='reviewByBodyType']").on("click", function() {
        const el = $(this);
        const params = {
            bodyType: el.val(),
            heightType: el.data('heightType'),
            rating: el.data('ratingType'),
            productSize: el.data('sizeValue'),
            productColor: el.data('colorValue'),
            sort: el.data('currentSort')
        };

        getReviews(params, 1, "body_type_filter");
        logEngagement(window.location.href, "PDP Reviews Main", params.bodyType + " Body Type Filter Selected");
    });

    $("input[name='reviewByHeight']").on("click", function() {
        const el = $(this);
        const params = {
            bodyType: el.data('bodyType'),
            heightType: el.val(),
            rating: el.data('ratingType'),
            productSize: el.data('sizeValue'),
            productColor: el.data('colorValue'),
            sort: el.data('currentSort')
        };

        getReviews(params, 1, "height_filter");
        logEngagement(window.location.href, "PDP Reviews Main", params.heightType + " Height Filter Selected");
    });

    $("input[name='review_sort_by']").on("click", function() {
        const el = $(this);
        const params = {
            bodyType: el.data('bodyType'),
            heightType: el.data('heightType'),
            rating: el.data('ratingType'),
            productSize: el.data('sizeValue'),
            productColor: el.data('colorValue'),
            sort: el.val()
        };

        getReviews(params, 1, "review_sort");
        logEngagement(window.location.href, "PDP Reviews Main", params.sort + " Selected");
    });

    $("input[name='reviewByRating']").on("click", function() {
        const el = $(this);
        const params = {
            bodyType: el.data('bodyType'),
            heightType: el.data('heightType'),
            rating: el.val(),
            productSize: el.data('sizeValue'),
            productColor: el.data('colorValue'),
            sort: el.data('currentSort')
        };

        getReviews(params, 1, "rating_filter");
        logEngagement(window.location.href, "PDP Reviews Main", params.ratingType + " Rating Filter Selected");
    });

    $("input[name='reviewBySize']").on("click", function() {
        const el = $(this);
        const params = {
            bodyType: el.data('bodyType'),
            heightType: el.data('heightType'),
            rating: el.data('ratingType'),
            productSize: el.val(),
            productColor: el.data('colorValue'),
            sort: el.data('currentSort')
        };

        getReviews(params, 1, "size_filter");
        logEngagement(window.location.href, "PDP Reviews Main", params.sizeType + " Size Filter Selected");
    });

    $("input[name='reviewByColor']").on("click", function() {
        const el = $(this);
        const params = {
            bodyType: el.data('bodyType'),
            heightType: el.data('heightType'),
            rating: el.data('ratingType'),
            productSize: el.data('sizeValue'),
            productColor: el.val(),
            sort: el.data('currentSort')
        };

        getReviews(params, 1, "color_filter");
        logEngagement(window.location.href, "PDP Reviews Main", params.colorType + " Color Filter Selected");
    });

    $(".js-review-pagination").on("click", function() {
        const el = $(this);
        const page = el.data('page');
        const params = {
            bodyType: el.data('bodyType'),
            heightType: el.data('heightType'),
            rating: el.data('ratingType'),
            productSize: el.data('sizeValue'),
            productColor: el.data('colorValue'),
            sort: el.data('currentSort')
        };

        getReviews(params, page, el.attr("id"));
        logEngagement(window.location.href, page, 'Review page click');
    });
}


// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/customer-reviews.js